export enum AiAgentTypeEnum {
  GAIA = 0,
  ThirdParty = 1,
}
